<template>
  <van-list
    v-model:loading="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <div class="asklist" v-for="item in askList" :key="item.id">
      <router-link :to="{
                path: '/forum/detail',
                query: {
                  id: item.id,
                  cate_id: item.cate_id,
                  title: '我的提问',
                },
              }">
        <p class="asklist-admin"><span> {{ item.add_time }}</span></p>
        <p class="asklit-desc ellipsis2">{{ item.title }}<span class="asklit-desc__tab" v-if="item.is_answer == 1">已回答</span></p>
        <router-link :to="{path:'/forum/detail',query:{id:item.id,title:'线上论坛',cate_id:'2'}}" v-if="item.is_answer == 1" class="asklit-desc ellipsis2" style="display:block;float:right;margin-top:-60px;padding:7px 13px;background-color:#ebedf3;border-radius:20px;color:#829ba1;">参与讨论</router-link>
        <p v-if="item.is_answer == 1" class="asklit-desc ellipsis2" style="padding:7px 10px;border-radius:7px;background-color:#f7f7f7;">雾森官方：{{item.answer}}</p>
      </router-link>
    </div>
  </van-list>
</template>
<script setup>
import { ref } from "vue";
import ajax from "@/utils/request.js";

const askList = ref([]);

const page = ref(1);
const loading = ref(false);
const finished = ref(false);


function getAskList() {
  loading.value = true
  const data = {
    typeid: 1,
    page: page.value
  }
  return ajax.post("users/getforumlist", data).then(res => {
    if (res.data.length < 10) {
      askList.value = askList.value.concat(res.data)
      finished.value = true
    } else {
      askList.value = askList.value.concat(res.data)
      page.value++
    }
  }).catch(()=>{
    finished.value = true;
  });
}
getAskList().finally(() => {
  loading.value = false
})

const onLoad = () => {
  getAskList().finally(() => {
  loading.value = false;
});
}
</script>
<style scoped>
.asklist {
  margin-bottom: 2.6667vw;
  padding: 5.3333vw 4vw;
  background-color: #fff;
}
.asklist-admin {
  font-size: 3.7333vw;
  color: #666666;
}
.asklist-admin span {
  font-size: 12px;
  color: #999999;
}
.asklit-desc {
  font-size: 14px;
  color: #333333;
  margin-top: 4.2667vw;
}
.asklit-desc__tab {
  padding: 3px 6px;
  background-color: #eee;
  color: #999;
  font-size: 12px;
  margin-left: 5px;
  border-radius: 15px;
}
</style>